import Axios from "axios";

import { reactive } from "vue";

export class Errors {
    constructor(errors = null) {
        this._errors = reactive({});
        this._message = "";

        this.set({});

        if (errors && typeof errors === "object") {
            this.set(errors);
        }
    }

    clear() {
        this._errors = {};
        this._message = "";
    }

    setErrorMessage(message) {
        this._message = message;
    }

    set(errors) {
        this._errors = errors;
    }

    errorMessage() {
        return this._message;
    }

    get(key) {
        let error = this._errors[key];

        return Array.isArray(error) ? error[0] : null;
    }

    all() {
        return this._errors;
    }

    empty() {
        return Object.keys(this._errors).length <= 0;
    }
}

class ApiResponse {
    constructor(data) {
        this._original = data;
        this._errors = new Errors();
        this._data = {};

        this._errors = new Errors();
        this._data = {};

        if (data instanceof Error) {
            if (data.response && data.response.data.exception) {
                return;
            }

            this._data = data.response.data;

            if (this._data.errors) {
                this._errors.set(this._data.errors);
            }

            if (this._data.message && !this._data.errors) {
                this._errors.setErrorMessage(this._data.message);
            }
        } else {
            this._data = data.data.data;
        }
    }

    data() {
        return this._data;
    }

    hasErrors() {
        return (
            !this._errors.empty() ||
            (this._errors._message && this._errors._message.length)
        );
    }

    errors() {
        return this._errors;
    }

    error(key) {
        return this._errors.get(key);
    }
}

export default class Client {
    constructor() {
        this.apiVersion = "v1";
        this.base = `/web-api/${this.apiVersion}/`;

        this.client = Axios.create({
            baseURL: this.base,
            headers: {
                "X-Requested-With": "XMLHttpRequest",
                "X-CSRF-TOKEN": document
                    .querySelector('meta[name="csrf-token"]')
                    .getAttribute("content")
            }
        });
    }

    errors() {
        return new Errors();
    }

    async get(path, query = {}, options = {}) {
        try {
            return await this.response(
                await this.client.get(path, {
                    ...options,
                    params: query
                })
            );
        } catch (e) {
            return await this.response(e);
        }
    }

    /**
     *
     * @param path
     * @param data
     * @param options
     * @returns {Promise<ApiResponse>}
     */
    async post(path, data = {}, options = {}) {
        try {
            return await this.response(
                await this.client.post(path, data, options)
            );
        } catch (e) {
            return await this.response(e);
        }
    }

    /**
     *
     * @param path
     * @param file
     * @param data
     * @returns {Promise<ApiResponse>}
     */
    async postFile(path, file, data = null) {
        try {
            const formData = new FormData();

            if (file) {
                formData.append("file", file);
            }

            if (data) {
                Object.keys(data).forEach(key => {
                    formData.append(key, data[key]);
                });
            }

            return await this.response(
                await this.client.post(path, formData, {
                    "Content-Type": "multipart/form-data"
                })
            );
        } catch (e) {
            return await this.response(e);
        }
    }

    /**
     *
     * @param path
     * @param data
     * @param options
     * @returns {Promise<ApiResponse>}
     */
    async patch(path, data = {}, options = {}) {
        try {
            return await this.response(
                await this.client.patch(path, data, options)
            );
        } catch (e) {
            return await this.response(e);
        }
    }

    /**
     *
     * @param data
     * @returns {Promise<ApiResponse>}
     */
    async response(data) {
        return new ApiResponse(data);
    }

    static instance() {
        if (!Client._instance) {
            Client._instance = new Client();
        }

        return Client._instance;
    }
}
